import classNames from "classnames/dedupe";
import React, { FC } from "react";

import LinkList, {
  ILinkListProps,
} from "../../ActionsSelectors/LinkList/LinkList";

export interface IFooterListProps extends ILinkListProps {
  titleText?: string;
  fontVariant?: "default" | "medium";
}

/** Helper component, decorates 'LinkList' with predefined Footer classes */
const FooterList: FC<IFooterListProps> = (props) => {
  const {
    titleText,
    classes,
    children,
    fontVariant = "default",
    ...other
  } = props;

  const linkClasses = classNames("text-regular text-decoration-none", {
    "fw-medium": fontVariant === "medium",
  });

  return (
    <LinkList
      listTitle={titleText && <div className="footer-heading">{titleText}</div>}
      classes={{
        root: "list-unstyled p-0 m-0",
        listItem: "mb-5",
        link: linkClasses,
      }}
      {...other}
    >
      {children}
    </LinkList>
  );
};

export default FooterList;
